


import {
  defineComponent,
  PropType,
  reactive,
  computed,
} from '@vue/composition-api';
import { useStore } from '@/hooks/useStore';
import useSettouPatrolContext from '@/components/Sp/Johaisetsu/SettouPatrol/composables/useSettouPatrolContext';
import { Location } from '@/models/index';
import { JohaisetsuSettouPatrolCreateParamsCommon } from '@/models/apis/johaisetsu/settouPatrol/johaisetsuSettouPatrolRequestCommon';

interface State {
  managerName: string;
  phoneNumber: string;
}

export default defineComponent({
  props: {
    displayJohaisetsuHan: {
      type: String,
      required: true,
    },
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    currentLocation: {
      type: Object as PropType<Location>,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
    isValidInput: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive<State>({
      managerName: '',
      phoneNumber: '',
    });
    const store = useStore();
    const userState = store.state.user;
    const {
      state: settouPatrolContextState,
      johaisetsuTypeGroupName,
      workType,
      johaisetsuTypes,
      isShowJohaisetsuTypeSelect,
      workStartLabel,
    } = useSettouPatrolContext({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const startMoving = async() => {
      const johaisetsuRoleMap = window.master.johaisetsuRoles.vals ?? '';
      const johaisetsuSettouPatrolCreateParams: JohaisetsuSettouPatrolCreateParamsCommon = {
        // device_idはCommon側でセットする
        device_id: '',
        base_departure_ts: new Date(),
        johaisetsu_company_id: johaisetsuRoleMap.filter(e => e.key === userState.johaisetsu_role)[0].id,
        johaisetsu_han_name: props.displayJohaisetsuHan,
        johaisetsu_type: johaisetsuTypeGroupName,
        work_type: workType,
        manager_name: state.managerName,
        phone_number: state.phoneNumber,
      };

      emit(
        'startMovingOnCommon',
        johaisetsuSettouPatrolCreateParams,
        settouPatrolContextState.selectedJohaisetsuType,
      );
    };
    const isStartButtonDisabled = computed(() => {
      return props.isRequesting || !props.isValidInput;
    });

    return {
      state,
      settouPatrolContextState,
      johaisetsuTypes,
      isShowJohaisetsuTypeSelect,
      workStartLabel,
      startMoving,
      isStartButtonDisabled,
    };
  },
});
